import React, { createContext } from "react";
import BgForm from "../../images/bg-form.png";
import IconNoti from "../../images/icon-noti.svg";
import $axios from "../../services/axios";
import { Button, message, Modal } from "antd";
import moment from "moment";
import { calculateTimeDifference } from "../../helpers/utils";
import { formatDateNoTime, formatTime } from "../../helpers/formatDate";
import _ from "lodash";
const ReachableContext = createContext(null);

const Step5 = ({
  bookingInfo,
  chooseFlight,
  airportInfo,
  isPromotionOrSameDayTicket,
  airlineInfo,
  airports,
  setLoading,
}) => {
  const baggage = _.sum([
    bookingInfo.totalListPrice.baggage,
    bookingInfo.totalListPrice.baggage_out,
  ]);
  const [modal, contextHolder] = Modal.useModal();
  const config = {
    title: "Thông báo!",
    maskClosable: false,
    closable: false,
    footer: [
      <div className="text-center w-full">
        <Button
          key="ok"
          type="primary"
          onClick={() => (window.location.href = "/vemaybay")}
        >
          Về trang tìm kiếm
        </Button>
      </div>,
    ],
    content: (
      <>
        <ReachableContext.Consumer>
          {() => (
            <div className="text-[14px] text-[#0D1634] font-medium">
              Đã hết hạn thanh toán. Vui lòng tìm kiếm lại chuyến bay để cập
              nhật!
            </div>
          )}
        </ReachableContext.Consumer>
        <br />
      </>
    ),
  };

  const handlePayment = async () => {
    // Send orderCode for IOS
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.NativeJavascriptInterface
    ) {
      // Chuyển đổi dữ liệu thành chuỗi JSON và gửi qua Swift
      window.webkit.messageHandlers.NativeJavascriptInterface.postMessage({
        orderCode: bookingInfo.orderId,
      });
    } else {
      console.error(
        "NativeJavascriptInterface không tồn tại hoặc không được hỗ trợ."
      );
    }
    // Send orderCode for Android
    if (window.webkit !== undefined) {
      if (window.webkit.messageHandlers.appInterface !== undefined) {
        window.webkit.messageHandlers.appInterface.postMessage(
          JSON.stringify({
            orderCode: bookingInfo.orderId,
          })
        );
      }
    }
    if (window.appInterface !== undefined) {
      window.appInterface.postMessage(
        JSON.stringify({
          orderCode: bookingInfo.orderId,
        })
      );
    }
    window.location.href = bookingInfo.paymentUrl;
  };

  return (
    <div className="bg-[#F6F6F6] mb-4">
      <div className="bg-accent h-[300px] relative">
        <section className="step-indicator">
          <div className="step step1 actived">
            <div
              className="step-icon"
              onClick={() => (window.location.href = "/vemaybay")}
            >
              1
            </div>
            <p>Tìm kiếm</p>
          </div>
          <div className="indicator-line active"></div>
          <div className="step step2 actived">
            <div className="step-icon">2</div>
            <p>Thông tin</p>
          </div>
          <div className="indicator-line active"></div>
          <div className="step step3 actived">
            <div className="step-icon">3</div>
            <p>Xác nhận</p>
          </div>
          <div className="indicator-line active"></div>
          <div className="step step4 active">
            <div className="step-icon">4</div>
            <p>Thanh Toán</p>
          </div>
        </section>
        <img src={BgForm} alt="" className="w-full object-cover mx-auto" />
        <div className="flex w-full absolute top-[135px] left-1/2 transform -translate-x-1/2 justify-center gap-8">
          <div className="flex flex-col gap-1">
            <div className="text-primary font-semibold text-[18px]">
              {chooseFlight?.[0]?.options?.[0]?.flights?.[0]?.startPoint}
            </div>
            <div className="text-primary font-medium text-[11px]">
              {
                airports?.find(
                  (item) =>
                    item.code ===
                    chooseFlight[0].options?.[0]?.flights?.[0]?.startPoint
                )?.nameVn
              }{" "}
            </div>
          </div>
          <div className="relative">
            <svg
              width="123"
              height="47"
              viewBox="0 0 123 47"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-primary"
            >
              <path
                d="M0 20L5 22.8868V17.1132L0 20ZM123 20L118 17.1132V22.8868L123 20ZM4.5 20.5H118.5V19.5H4.5V20.5Z"
                fill="white"
              />
              <g filter="url(#filter0_d_212_3608)">
                <circle cx="62.5" cy="19.5" r="19.5" fill="white" />
              </g>
              <path
                d="M71.7335 30.404L73.3261 28.1785L68.063 16.3724L72.4426 10.2524C73.1035 9.32878 72.8628 8.06044 71.9037 7.4128C70.9446 6.76516 69.6368 6.9879 68.9759 7.91147L64.5963 14.0316L51.3703 13.3529L49.7777 15.5784L61.013 19.0389L56.6333 25.159L53.1278 25.2675L51.9333 26.9366L56.7741 28.5549L60.0223 32.3987L61.2167 30.7296L60.1 27.4999L64.4797 21.3798L71.7335 30.404Z"
                fill="currentColor"
              />
              <defs>
                <filter
                  id="filter0_d_212_3608"
                  x="39"
                  y="0"
                  width="47"
                  height="47"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_212_3608"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_212_3608"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <div className="flex flex-col gap-1">
            <div className="text-primary font-semibold text-[18px]">
              {chooseFlight?.[0]?.options?.[0]?.flights?.[0]?.endPoint}
            </div>
            <div className="text-primary font-medium text-[11px]">
              {
                airports?.find(
                  (item) =>
                    item.code ===
                    chooseFlight[0].options?.[0]?.flights?.[0]?.endPoint
                )?.nameVn
              }{" "}
            </div>
          </div>
        </div>
        <div className="w-[90%] mx-auto absolute top-[200px]  left-1/2 transform -translate-x-1/2 pb-[120px] flex flex-col">
          <div
            style={{
              boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
            }}
            className="rounded-[20px] bg-white shadow-lg p-4 mb-[24px] text-[14px] text-[#27272A]"
          >
            <div>
              <div className="flex gap-3">
                <img
                  className="w-[60px] h-[30px]"
                  src={`${process.env.REACT_APP_BASE_URL}/${chooseFlight[0]?.airline?.iconUrl}`}
                  alt=""
                />
                <div className="flex flex-col gap-1">
                  <div className="font-bold text-[#27272A]">
                    {
                      airports?.find(
                        (item) =>
                          item.code ===
                          chooseFlight[0].options?.[0]?.flights?.[0]?.startPoint
                      )?.nameVn
                    }
                  </div>
                  {chooseFlight[0].options?.[0]?.flights?.[0]?.segments?.map(
                    (segment, index) => (
                      <div className="text-[#808089]" key={index}>
                        {segment?.flightNumber || ""}/ {segment?.fareClassName}
                      </div>
                    )
                  )}
                </div>
              </div>
              <hr
                style={{ borderTopWidth: "0.5px", borderColor: "#ebebf0" }}
                className="my-3"
              />
              <div className="flex w-full justify-between items-center">
                <div className="flex flex-col">
                  <div className="font-bold">
                    {chooseFlight?.[0]?.options?.[0]?.flights?.[0]?.startPoint}
                  </div>
                  <div className="text-[12px]">
                    {formatTime(
                      chooseFlight[0]?.options?.[0]?.flights?.[0]?.startDate
                    )}
                  </div>
                  <div className="text-[12px]">
                    {formatDateNoTime(
                      chooseFlight[0]?.options?.[0]?.flights?.[0]?.startDate
                    )}
                  </div>
                </div>
                <div className="relative w-full">
                  <div className="text-[12px] w-full text-center text-[#808089] absolute left-1/2 transform -translate-x-1/2 bottom-[12px]">
                    {calculateTimeDifference(
                      chooseFlight[0]?.options?.[0]?.flights?.[0]?.startDate,
                      chooseFlight[0]?.options?.[0]?.flights?.[0]?.endDate
                    )}
                  </div>
                  <svg
                    width="156"
                    height="19"
                    viewBox="0 0 156 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="text-primary absolute bottom-[-15px] left-1/2 transform -translate-x-1/2"
                  >
                    <circle
                      cx="9"
                      cy="10"
                      r="9"
                      fill="currentColor"
                      fill-opacity="0.1"
                    />
                    <circle
                      cx="9.0001"
                      cy="10"
                      r="6.42857"
                      fill="currentColor"
                      fill-opacity="0.25"
                    />
                    <circle
                      cx="8.99997"
                      cy="10"
                      r="3.85714"
                      fill="currentColor"
                    />
                    <circle
                      cx="147"
                      cy="10"
                      r="9"
                      fill="currentColor"
                      fill-opacity="0.1"
                    />
                    <circle
                      cx="147"
                      cy="10"
                      r="6.42857"
                      fill="currentColor"
                      fill-opacity="0.25"
                    />
                    <circle cx="147" cy="10" r="3.85714" fill="currentColor" />
                    <line
                      x1="22.5"
                      y1="9.5"
                      x2="66.5"
                      y2="9.5"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-dasharray="5 3"
                    />
                    <line
                      x1="89.5"
                      y1="9.5"
                      x2="133.5"
                      y2="9.5"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-dasharray="5 3"
                    />
                    <path
                      d="M87 9.4C87 10.12 86.37 10.75 85.65 10.75H80.7L76.2 17.95H74.4L76.65 10.75H71.7L70.35 12.55H69L69.9 9.4L69 6.25H70.35L71.7 8.05H76.65L74.4 0.850004H76.2L80.7 8.05H85.65C86.37 8.05 87 8.68 87 9.4Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <div className="flex flex-col">
                  <div className="font-bold">
                    {chooseFlight[0]?.options?.[0]?.flights?.[0]?.endPoint}
                  </div>
                  <div className="text-[12px]">
                    {formatTime(
                      chooseFlight[0]?.options?.[0]?.flights?.[0]?.endDate
                    )}
                  </div>
                  <div className="text-[12px]">
                    {formatDateNoTime(
                      chooseFlight[0]?.options?.[0]?.flights?.[0]?.endDate
                    )}
                  </div>
                </div>
              </div>
            </div>
            {chooseFlight?.[0]?.options?.[0]?.flights?.[0]?.stopNum > 0 &&
              _.slice(
                chooseFlight?.[0]?.options?.[0]?.flights?.[0]?.segments,
                0,
                -1
              ).map((s) => (
                <div
                  key={s.id}
                  style={{ border: "1px solid #DDDDE3" }}
                  className="flex gap-2 p-2 rounded-[4px] my-4 items-center"
                >
                  <img src={IconNoti} alt="" />
                  <span>
                    Dừng để đổi chuyến bay tại{" "}
                    {airports?.find((item) => item.code === s.stopPoint)?.name}{" "}
                    ({s.stopTime}
                    m)
                  </span>
                </div>
              ))}
            {chooseFlight.length === 2 && (
              <>
                <div className="mt-[24px]">
                  <div className="flex gap-3">
                    <img
                      className="w-[60px] h-[30px]"
                      src={`${process.env.REACT_APP_BASE_URL}/${chooseFlight[1]?.airline?.iconUrl}`}
                      alt=""
                    />
                    <div className="flex flex-col gap-1">
                      <div className="font-bold text-[#27272A]">
                        {
                          airports?.find(
                            (item) =>
                              item.code ===
                              chooseFlight[1].options?.[0]?.flights?.[0]
                                ?.startPoint
                          )?.nameVn
                        }
                      </div>
                      {chooseFlight[1].options?.[0]?.flights?.[0]?.segments?.map(
                        (segment, index) => (
                          <div className="text-[#808089]" key={index}>
                            {segment?.flightNumber || ""}/ {segment?.fareClassName}
                          </div>
                        )
                      )}
                    </div>
                  </div>
                  <hr
                    style={{ borderTopWidth: "0.5px", borderColor: "#ebebf0" }}
                    className="my-3"
                  />
                  <div className="flex w-full justify-between items-center">
                    <div className="flex flex-col">
                      <div className="font-bold">
                        {
                          chooseFlight?.[1]?.options?.[0]?.flights?.[0]
                            ?.startPoint
                        }
                      </div>
                      <div className="text-[12px]">
                        {formatTime(
                          chooseFlight[1]?.options?.[0]?.flights?.[0]?.startDate
                        )}
                      </div>
                      <div className="text-[12px]">
                        {formatDateNoTime(
                          chooseFlight[1]?.options?.[0]?.flights?.[0]?.startDate
                        )}
                      </div>
                    </div>
                    <div className="relative w-full">
                      <div className="text-[12px] w-full text-center text-[#808089] absolute left-1/2 transform -translate-x-1/2 bottom-[12px]">
                        {calculateTimeDifference(
                          chooseFlight[1]?.options?.[0]?.flights?.[0]
                            ?.startDate,
                          chooseFlight[1]?.options?.[0]?.flights?.[0]?.endDate
                        )}
                      </div>
                      <svg
                        width="156"
                        height="19"
                        viewBox="0 0 156 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="text-primary absolute bottom-[-15px] left-1/2 transform -translate-x-1/2"
                      >
                        <circle
                          cx="9"
                          cy="10"
                          r="9"
                          fill="currentColor"
                          fill-opacity="0.1"
                        />
                        <circle
                          cx="9.0001"
                          cy="10"
                          r="6.42857"
                          fill="currentColor"
                          fill-opacity="0.25"
                        />
                        <circle
                          cx="8.99997"
                          cy="10"
                          r="3.85714"
                          fill="currentColor"
                        />
                        <circle
                          cx="147"
                          cy="10"
                          r="9"
                          fill="currentColor"
                          fill-opacity="0.1"
                        />
                        <circle
                          cx="147"
                          cy="10"
                          r="6.42857"
                          fill="currentColor"
                          fill-opacity="0.25"
                        />
                        <circle
                          cx="147"
                          cy="10"
                          r="3.85714"
                          fill="currentColor"
                        />
                        <line
                          x1="22.5"
                          y1="9.5"
                          x2="66.5"
                          y2="9.5"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-dasharray="5 3"
                        />
                        <line
                          x1="89.5"
                          y1="9.5"
                          x2="133.5"
                          y2="9.5"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-dasharray="5 3"
                        />
                        <path
                          d="M87 9.4C87 10.12 86.37 10.75 85.65 10.75H80.7L76.2 17.95H74.4L76.65 10.75H71.7L70.35 12.55H69L69.9 9.4L69 6.25H70.35L71.7 8.05H76.65L74.4 0.850004H76.2L80.7 8.05H85.65C86.37 8.05 87 8.68 87 9.4Z"
                          fill="currentColor"
                        />
                      </svg>
                    </div>
                    <div className="flex flex-col">
                      <div className="font-bold">
                        {chooseFlight[1]?.options?.[0]?.flights?.[0]?.endPoint}
                      </div>
                      <div className="text-[12px]">
                        {formatTime(
                          chooseFlight[1]?.options?.[0]?.flights?.[0]?.endDate
                        )}
                      </div>
                      <div className="text-[12px]">
                        {formatDateNoTime(
                          chooseFlight[1]?.options?.[0]?.flights?.[0]?.endDate
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {chooseFlight?.[1]?.options?.[0]?.flights?.[0]?.stopNum > 0 &&
                  _.slice(
                    chooseFlight?.[1]?.options?.[0]?.flights?.[0]?.segments,
                    0,
                    -1
                  ).map((s) => (
                    <div
                      key={s.id}
                      style={{ border: "1px solid #DDDDE3" }}
                      className="flex gap-2 p-2 rounded-[4px] my-4 items-center"
                    >
                      <img src={IconNoti} alt="" />
                      <span>
                        Dừng để đổi chuyến bay tại{" "}
                        {
                          airports?.find((item) => item.code === s.stopPoint)
                            ?.nameVn
                        }{" "}
                        ({s.stopTime}
                        m)
                      </span>
                    </div>
                  ))}
              </>
            )}
            <hr className="my-4" style={{ borderTopWidth: "2px" }} />
            <ul className="list-none py-4">
              {chooseFlight[0].adt > 0 && (
                <li className="flex justify-between mb-2">
                  <span>{chooseFlight[0].adt} người lớn</span>
                  <span>
                    {bookingInfo.totalListPrice?.totalFareAdt?.toLocaleString(
                      "vi-VN"
                    )}{" "}
                    ₫
                  </span>
                </li>
              )}
              {chooseFlight[0].chd > 0 && (
                <li className="flex justify-between mb-2">
                  <span>{chooseFlight[0].chd} trẻ em</span>
                  <span>
                    {bookingInfo.totalListPrice?.totalFareChd?.toLocaleString(
                      "vi-VN"
                    )}{" "}
                    ₫
                  </span>
                </li>
              )}
              {chooseFlight[0].inf > 0 && (
                <li className="flex justify-between mb-2">
                  <span>{chooseFlight[0].inf} em bé</span>
                  <span>
                    {bookingInfo.totalListPrice?.totalFareInf?.toLocaleString(
                      "vi-VN"
                    )}{" "}
                    ₫
                  </span>
                </li>
              )}
              {bookingInfo.totalListPrice.totalTax > 0 && (
                <li className="flex justify-between mb-2">
                  <span>Thuế</span>
                  <span>
                    {bookingInfo.totalListPrice?.totalTax?.toLocaleString(
                      "vi-VN"
                    )}{" "}
                    ₫
                  </span>
                </li>
              )}
              {baggage > 0 && (
                <li className="flex justify-between mb-2">
                  <span>Hành lý</span>
                  <span>{baggage?.toLocaleString("vi-VN")} ₫</span>
                </li>
              )}
              {bookingInfo.voucherValue > 0 && (
                <li className="flex justify-between mb-2">
                  <span>Giảm giá</span>
                  <span className="text-[#00AB56]">
                    -{bookingInfo?.voucherValue?.toLocaleString("vi-VN")} ₫
                  </span>
                </li>
              )}
              <li className="flex justify-between">
                <span className="font-bold">
                  Tổng số tiền (đã bao gồm chi phí)
                </span>
                <span className="font-bold text-primary">
                  {bookingInfo.totalListPrice?.totalDisplay?.toLocaleString(
                    "vi-VN"
                  )}{" "}
                  ₫
                </span>
              </li>
            </ul>
          </div>
          <Button
            onClick={handlePayment}
            type="primary"
            className="w-[208px] h-[45px] rounded-[10px] text-center mx-auto text-[15px]"
          >
            <span className="font-semibold">Thanh toán</span>
          </Button>
        </div>
        {/* <div className="flex bg-white h-[81px] w-full px-[24px] py-3 fixed bottom-0 justify-between items-center">
          <div className="flex flex-col items-center">
            <img className="w-[28px]" src={"../images/ve-may-bay.svg"} alt="" />
            <a href="/ve-may-bay" className="text-secondary text-[14px] font-medium">
              Vé máy bay
            </a>
          </div>
          <div className="flex flex-col items-center">
            <img className="w-[28px]" src={"../images/khach-san.svg"} alt="" />
            <span className="text-[#808080CC] text-[14px] font-medium">Khách sạn</span>
          </div>
          <div className="flex flex-col items-center">
            <img className="w-[28px]" src={"../images/ve-tau.svg"} alt="" />
            <span className="text-[#808080CC] text-[14px] font-medium">Vé tàu</span>
          </div>
          <div className="flex flex-col items-center">
            <img className="w-[28px]" src={"../images/ve-xe.svg"} alt="" />
            <span className="text-[#808080CC] text-[14px] font-medium">Vé xe</span>
          </div>
        </div> */}
      </div>
      {contextHolder}
    </div>
  );
};

export default Step5;
